import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0416] text-white text-base md:text-lg w-full py-4 flex flex-col items-center space-y-1 md:space-y-0 md:flex-row md:justify-center border-t border-gray-700">
      {/* "Designed and Developed by" text */}
      <div className="flex-1 text-center">
        <h3 className="font-semibold">Designed and Developed by Eli Nichols</h3>
      </div>


      {/* Copyright text */}
      <div className="flex-1 text-center">
        <h3 className="font-semibold">Copyright &copy; {new Date().getFullYear()} EN</h3>
      </div>
    </footer>
  );
};

export default Footer;
